var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { errors } from '@feathersjs/client';
import * as Raven from 'raven-js';
import { feathersServices } from 'src/feathers';
import getUtcStringFromOffset from 'src/imports/getUtcStringFromOffset';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import InputName from './InputName';
import InputCode from './InputCode';
import InputScoreSystem from './InputScoreSystem';
import InputDate from './InputDate';
import InputRoutes from './InputRoutes';
import InputStatus from './InputStatus';
import FormRoute from '../FormRoute';
import ButtonSubmit from 'src/pages/components/forms/ButtonSubmit';
import ButtonCancel from 'src/pages/components/forms/ButtonCancel';
import ButtonDelete from 'src/pages/components/forms/ButtonDelete';
var formStyles = require('src/imports/styles/extend.form.scss');
var FormRound = (function (_super) {
    __extends(FormRound, _super);
    function FormRound(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
        };
        _this.handleSubmitForm = _this.handleSubmitForm.bind(_this);
        return _this;
    }
    FormRound.prototype.handleSubmitForm = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var formValues, round, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.setState({ isFetching: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, new Promise(function (resolve, reject) {
                                _this.props.form.validateFieldsAndScroll({ scroll: { offsetTop: 96 } }, function (err, res) {
                                    if (err) {
                                        reject(err);
                                    }
                                    if (!err) {
                                        resolve(res);
                                    }
                                });
                            })];
                    case 2:
                        formValues = _a.sent();
                        round = {
                            id: this.props.round && this.props.round.id,
                            name: formValues.name,
                            code: formValues.code,
                            dateStart: formValues.date[0].startOf('minute').utcOffset(this.props.event.utcOffset, true).toISOString(),
                            dateEnd: formValues.date[1].startOf('minute').utcOffset(this.props.event.utcOffset, true).toISOString(),
                        };
                        return [4, this.props.handlePatchRound(round)];
                    case 3:
                        response = _a.sent();
                        if (response.action.type === feathersServices.rounds.types.SERVICES_ROUNDS_PATCH_FULFILLED) {
                            this.setState({ isFetching: false });
                            message.success('Round was successfully saved!');
                        }
                        else {
                            throw new errors.GeneralError('Round was not saved');
                        }
                        return [3, 5];
                    case 4:
                        err_1 = _a.sent();
                        this.setState({ isFetching: false });
                        Raven.captureException(err_1);
                        if (err_1.message) {
                            message.error(err_1.message);
                        }
                        else {
                            message.error('There are several errors in your data. Please correct them');
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    FormRound.prototype.render = function () {
        var _this = this;
        var form = this.props.form;
        var event = this.props.event;
        var round = this.props.round;
        var isFetching = this.state.isFetching;
        return (React.createElement(Form, { className: formStyles.form, hideRequiredMark: true, onSubmit: this.handleSubmitForm },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: { span: 24, push: 0 }, xl: { span: 8, push: 16 } },
                    React.createElement(Card, { className: formStyles.card },
                        React.createElement("h2", { className: formStyles.header }, "Round Status"),
                        React.createElement(InputStatus, { round: round, handlePatchRound: this.props.handlePatchRound }))),
                React.createElement(Col, { xs: { span: 24, push: 0 }, xl: { span: 16, pull: 8 } },
                    React.createElement(Card, { className: formStyles.card },
                        React.createElement("h2", { className: formStyles.header }, "Round Info"),
                        React.createElement(InputName, { form: form, isDisabled: isFetching, initialValue: round && round.name }),
                        React.createElement(InputCode, { form: form, isDisabled: isFetching, initialValue: round && round.code }),
                        React.createElement(InputDate, { form: form, isDisabled: isFetching, utcOffset: event.utcOffset, timezoneDisplay: getUtcStringFromOffset(event.utcOffset), initialValueStart: round && round.dateStart, initialValueEnd: round && round.dateEnd })))),
            (round && round.id)
                ? (React.createElement(Row, { gutter: 24 },
                    React.createElement(Col, { xs: { span: 24, push: 0 }, xl: { span: 8, push: 16 } },
                        React.createElement(Card, { className: formStyles.card },
                            React.createElement("h2", { className: formStyles.header }, "Score Format"),
                            React.createElement(InputScoreSystem, { form: form, isDisabled: !!round || isFetching, initialValue: round && round.scoreSystem }))),
                    React.createElement(Col, { xs: { span: 24, push: 0 }, xl: { span: 16, pull: 8 } },
                        React.createElement(Card, { className: formStyles.card },
                            React.createElement("h2", { className: formStyles.header }, "Routes"),
                            this.props.routes &&
                                this.props.routes
                                    .sort(function (a, b) { return a.index - b.index; })
                                    .map(function (route) { return (React.createElement(FormRoute, { key: round.id, form: form, isDisabled: isFetching, round: round, route: route })); })))))
                : (React.createElement(Row, { gutter: 24 },
                    React.createElement(Col, { xs: 24, xl: 16 },
                        React.createElement(Card, { className: formStyles.card },
                            React.createElement("h2", { className: formStyles.header }, "Scoring & Routes/Problems"),
                            React.createElement(InputScoreSystem, { form: form, isDisabled: isFetching || true, initialValue: round && round.scoreSystem }),
                            React.createElement(InputRoutes, { form: form, isDisabled: isFetching, initialValue: round && round.routeCount }))))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Divider, null),
                    React.createElement("div", { className: formStyles.buttonsWrapper },
                        React.createElement("div", { className: formStyles.buttonsLeft },
                            round && (React.createElement(Form.Item, null,
                                React.createElement(ButtonDelete, { isDisabled: isFetching, deleteTitle: 'Delete round?', deleteContent: React.createElement("div", null,
                                        React.createElement("p", null,
                                            "This will delete your round, ",
                                            React.createElement("strong", null, this.props.event.name),
                                            " at ",
                                            React.createElement("strong", { style: { whiteSpace: 'nowrap' } },
                                                this.props.event.subdomain,
                                                ".crimp.rocks"),
                                            ", along with rounds, routes, teams and scores inside it. It will remove all links to participating athletes."),
                                        " ",
                                        React.createElement("p", null, "No more warnings will be given!")), navigateTo: function () { _this.props.navigateTo("/event/" + _this.props.event.subdomain + "/rounds"); } }))),
                            React.createElement(Form.Item, null,
                                React.createElement(ButtonCancel, { isDisabled: isFetching, action: function () { return form.resetFields(); } }))),
                        React.createElement("div", { className: formStyles.buttonsRight },
                            React.createElement(Form.Item, null,
                                React.createElement(ButtonSubmit, { isFetching: isFetching }))))))));
    };
    return FormRound;
}(React.Component));
export default Form.create()(FormRound);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormRoundPage/FormRound/index.tsx
// module id = 1184
// module chunks = 0